export type ProgressCallback = (path: string, progressEvent: ProgressEvent) => void;
export type { IAuth0TokenContext, IAwsUserContext, IAwsS3UploadContext } from "@/common/types";
